function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PaymentList from './payments/PaymentList.vue';
import RecurringPaymentList from './payments/RecurringPaymentList.vue';
import PaymentMethods from './payments/PaymentMethods.vue';

export default {
	components: {
		PaymentList: PaymentList,
		RecurringPaymentList: RecurringPaymentList,
		PaymentMethods: PaymentMethods
	},
	props: {
		resident: {
			default: null
		}
	},
	data: function data() {
		return {
			acceptedTos: true,
			hasPortalAccount: true,
			payments: [],
			recurringPayments: [],
			loading: true,
			paymentMethods: [],
			selected: 'payments',
			dwollaStatus: ''
		};
	},

	computed: {
		filteredRequests: function filteredRequests() {

			var filterKey = this.filterKey && this.filterKey.toLowerCase();
			var data = this.requests;
			if (filterKey) {
				data = data.filter(function (row) {
					return Object.keys(row).some(function (key) {
						return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
					});
				});
			}

			return data;
		}
	},
	created: function created() {
		var _this = this;

		Event.$on('get-resident-portal-info', function () {
			return _this.refreshData();
		});
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('get-resident-portal-info');
	},

	methods: {
		setTab: function setTab(tab) {
			this.selected = tab;
		},
		refreshData: function refreshData() {
			var $el = this;

			axios.get('/prototype/resident/payments/from-portal/' + this.resident.id).then(function (response) {
				if (response.data) {

					if (typeof response.data.payments == 'string') {
						$el.hasPortalAccount = false;
						$el.loading = false;
						return false;
					}

					$el.payments = response.data.payments.payments;
					$el.recurringPayments = response.data.payments.recurring;
					$el.paymentMethods = [].concat(_toConsumableArray(response.data.payments.checking_accounts), _toConsumableArray(response.data.payments.credit_cards));
					$el.acceptedTos = response.data.payments.acceptedTos;
					$el.loading = false;
					$el.dwollaStatus = response.data.payments.dwolla_status;
					$el.checking_accounts = response.data.payments.checking_accounts;
					$el.property = response.data.property;
				}
			});
		}
	},
	mounted: function mounted() {
		this.refreshData();
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentPortalInformation.vue
// module id = xMxg
// module chunks = 0 1